import React, { useEffect, useState, useRef } from "react";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./Context/AuthContext";

const Header = () => {
  const navigate = useNavigate();
  const { user, isLoggedIn, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isPublishingMenuOpen, setIsPublishingMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleProfileClick = () => {
    setDropdownOpen(false);
    navigate("/profile");
  };

  const handleLogoutClick = () => {
    logout();
    setDropdownOpen(false);
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMobileLinkClick = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  const handlePublishingToggle = (e) => {
    e.preventDefault();
    if (window.innerWidth <= 1024) {
      setIsPublishingMenuOpen(!isPublishingMenuOpen);
    }
  };

  return (
    <header className="site-header no-print">
      <div className="header-top-line">
        <nav className="header-top-nav">
          {isLoggedIn == true && user.email != null ? (
            <>
              <div className="header-top-user" ref={dropdownRef}>
                <div
                  className="header-top-user-id"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <img
                    className="header-top-user-id-img"
                    src="./images/icon_profile.png"
                    alt="icon_profile"
                  />
                  <div className="header-top-user-id-email">{user.email}</div>
                  <div
                    className={`header-top-user-id-arrow ${
                      dropdownOpen ? "up" : "down"
                    }`}
                  ></div>
                </div>
                <div
                  className={`header-top-user-dropdown ${
                    dropdownOpen ? "open" : ""
                  }`}
                >
                  <div
                    className="header-top-user-dropdown-item"
                    onClick={handleProfileClick}
                  >
                    마이페이지
                  </div>
                  <div
                    className="header-top-user-dropdown-item"
                    onClick={handleLogoutClick}
                  >
                    로그아웃
                  </div>
                </div>
              </div>

              {user.authorityType === "ADMIN" && (
                <a href="/admin">Admin Panel</a>
              )}
            </>
          ) : (
            // {/* <a href="/membership/">회원가입</a> */}
            <a href="/login">로그인</a>
            // {/* <a href="/customer-center/">고객센터</a> */}
          )}
        </nav>
      </div>
      <div className="header-bottom-line">
        <div className="header-bottom-line-left">
          <a id="logo" href="/">
            <img src="/images/logo.svg" alt="Acorn 로고" />
          </a>
          <nav
            className={`header-bottom-nav ${
              mobileMenuOpen ? "mobile-open" : ""
            }`}
          >
            <div
              className={`dropdown ${
                isPublishingMenuOpen ? "mobile-submenu-open" : ""
              }`}
            >
              <a
                href="#"
                onClick={handlePublishingToggle}
                className="dropdown-trigger"
              >
                출판 방식
              </a>
              <div className="dropdown-menu">
                <a href="/self-publishing">자비 출판</a>
                <a href="/semi-planned-publishing">반기획 출판</a>
                <a href="/planned-publishing">기획 출판</a>
                <a href="/amazon">아마존 킨들 출판 대행</a>
              </div>
            </div>
            <a
              href="https://acornpub.co.kr/category/%EC%A0%84%EC%B2%B4/25/"
              target="_blank"
              rel="noopener noreferrer"
            >
              출간 도서
            </a>
            <button
              className="faq-link-button"
              onClick={() => {
                navigate("/", { state: { scrollToFAQ: true } });
                setMobileMenuOpen(false);
              }}
            >
              자주 묻는 질문
            </button>
            <div className="dropdown">
              <a
                href="#"               
                className="dropdown-trigger"
              >
                회사 소개
              </a>
              <div className="dropdown-menu">
                <a href="/About">인사말</a>
                <a href="/Location">찾아오시는 길</a>
              </div>
            </div>            
            {/* <a href="/reviews">출판후기</a> */}
          </nav>
        </div>
        {/* <div className="header-bottom-line-right">
          <SearchBar />
        </div> */}
        <button
          className={`hamburger-button ${mobileMenuOpen ? "open" : ""}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
